// Copyright (c) 2016 Deere & Company

import './warranty-expiration.scss';
import * as busyCounterService from '../../../../src/shared/services/busy-counter';
import React, {
    Component,
    PropTypes
} from 'react';
import Criteria from '../../warranty-expiration/state/criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import Formatting from '../state/formatting';
import InlineAlertBar from '../../../shared/components/inline-alert-bar/index';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found/index';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import WarrantyAgGridDatePicker from '../../shared/components/ag-grid-date-picker';
import WarrantyExpirationReport from '@deere/cps-it.warranty-model-factory/lib/warranty-expiration';
import WarrantyExpirationReportCriteria from './warranty-expiration-report-criteria';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToCSV} from '../../shared/services/export-to-csv';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getDefaultReportLayout} from '../../shared/services/report-variant';
import {getWarrantyExpirationColumnDefinitions} from '../report-services/column-definitions';
import {scrollToAndResizeReport} from '../../shared/services/scroll-window';

function handleExpirationDateChange(expirationDateRange) {

    this.actions.updateWarrantyExpirationDateCriteria(expirationDateRange);

}

function handleWarrantyTypesSelect(warrantyType, isSelected) {

    this.actions.updateWarrantyExpirationTypesCriteria(warrantyType, isSelected);

}

function handleDealersSelect(dealer, isSelected) {

    this.actions.updateWarrantyExpirationAccountsCriteria(dealer, isSelected);

}

function handleCreateReportClick() {

    this.actions.toggleReportIsScrollable();
    this.actions.resetSearchResults();
    this.actions.createWarrantyExpirationReport();

}

function handleSelectAllDealers() {

    this.actions.warrantyExpirationSelectAllAccountsCriteria(this.selectedAccounts);

}

function handleSelectAllWarrantyTpes() {

    this.actions.warrantyExpirationSelectAllTypesCriteria();

}

function handleGridApiDefinition(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

function handleExportToCsv() {

    const fileName = 'warranty-expiration';

    return exportToCSV(fileName, this.gridApi);

}

function handleReset() {

    this.actions.resetWarrantyExpirationCriteria(this.selectedAccounts);
    this.actions.resetSearchResults();
    this.actions.updateShowNoResultsFound(false);

}

class WarrantyExpiration extends Component {

    componentWillMount() {

        this.props.actions.updateWarrantyTypes();
        this.props.actions.updateAllDealersOnLoad(this.props.selectedAccounts);
        this.props.actions.getReportLayouts('warranty-expiration');

    }

    componentDidUpdate(prevProps) {

        if (this.props.reportIsScrollable && this.props.report.length) {

            this.props.actions.resetReportIsScrollable();

            scrollToAndResizeReport();

        }

        const isFirstRun = !prevProps.report.length && !prevProps.showNoResultsFound;
        const layoutWasChanged = this.props.selectedLayout !== prevProps.selectedLayout;
        const readyToApplyLayout = this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable;

        if ((isFirstRun || layoutWasChanged) && readyToApplyLayout) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetSearchResults();
        this.props.actions.updateShowNoResultsFound(false);
        this.props.actions.resetReportVariant();

    }

    render() {

        const canRunReport = this.props.criteria.selectedDealers.length > 0 && this.props.criteria.warrantyTypes.selected.length > 0 && this.props.criteria.expirationDate.from > 0 && this.props.criteria.expirationDate.to > 0;

        const gridOptions = {
            dateComponentFramework: WarrantyAgGridDatePicker
        };

        return (
            <section className='warranty-expiration-report'>
                <WarrantyLoadingIndicator isLoading={busyCounterService.hasBusyCounter(this.props.busyCounter)}/>
                <h2 className='warranty-expiration-title'>
                    <FormattedMessage id='WARRANTY_EXPIRATION'/>
                    <FavoriteIcon
                        id='WARRANTY_EXPIRATION'
                        route={this.props.pathName}
                    />
                </h2>
                <WarrantyExpirationReportCriteria
                    allowedAccounts={this.props.selectedAccounts}
                    canExport={this.props.report.length > 0}
                    canRunReport={canRunReport}
                    criteria={this.props.criteria}
                    expirationDate={this.props.criteria.expirationDate}
                    onDealerSelectClick={this.props::handleDealersSelect}
                    onExpirationDateChange={this.props::handleExpirationDateChange}
                    onExportToCsv={this.props::handleExportToCsv}
                    onReset={this.props::handleReset}
                    onRunReport={this.props::handleCreateReportClick}
                    onSelectAllDealers={this.props::handleSelectAllDealers}
                    onSelectAllTypes={this.props::handleSelectAllWarrantyTpes}
                    onTypeSelectClick={this.props::handleWarrantyTypesSelect}
                />

                <InlineAlertBar label='SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE'/>

                {this.props.report.length ?
                    <div>
                        <NumberOfRecordsFound count={this.props.report.length}/>
                        <section className='report'>
                            {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                            <ReportHeader
                                columnApi={this.props.columnApi}
                                gridApi={this.props.gridApi}
                                reportName='warranty-expiration'
                            />
                            <ReportGrid
                                columnDefs={getWarrantyExpirationColumnDefinitions()}
                                gridOptions={gridOptions}
                                headerHeight='32'
                                localeText={getAgGridLocaleText()}
                                onColumnVisible={this.props::onColumnRemoved}
                                onGridReady={this.props::handleGridApiDefinition}
                                rowData={this.props.report}
                                rowHeight='32'
                            />
                        </section>
                    </div> :
                    <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>
                }
            </section>
        );

    }

}

WarrantyExpiration.displayName = 'WarrantyExpiration';
WarrantyExpiration.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    formatting: PropTypes.instanceOf(Formatting).isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    pathName: PropTypes.string.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(WarrantyExpirationReport)),
    reportIsScrollable: PropTypes.bool.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired
};

export default WarrantyExpiration;



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/components/warranty-expiration.js